module.exports = __webpack_public_path__ + "static/media/ios_download.1b659262.svg";